export const translation = {
  'home.hero.title1': 'TOP GYM',
  'home.hero.title2': 'CUMBUCO',
  'home.hero.subtitle': 'Musculação, funcional e aulas para você manter a rotina perto da praia.',
  'home.hero.ctaWhatsApp': 'Chamar no WhatsApp',
  'home.hero.ctaMap': 'Ver localização',
  'home.hero.priceBadge': 'A partir de R$ 169/mês',
  'home.hero.priceBadgeLine1': 'A partir de',
  'home.hero.priceBadgeLine2': 'R$169',
  'home.hero.videoTitle': 'Top Gym Cumbuco - Treino de verdade perto da praia',
  'home.hero.videoAriaLabel': 'Vídeo da academia Top Gym Cumbuco mostrando estrutura e treinos',

  'home.info.gym': 'Academia em Cumbuco',
  'home.info.classes': 'Musculação e aulas',
  'home.info.whatsapp': 'WhatsApp para planos',
  'home.info.beach': 'Perto da Praia de Cumbuco',

  'home.info.area.value': '500',
  'home.info.area.label': 'm² de área de treino',
  'home.info.classes.value': '15',
  'home.info.classes.label': 'Aulas por semana',
  'home.info.hours.value': '16',
  'home.info.hours.label': 'Horas de funcionamento',
  'home.info.beach.value': '200',
  'home.info.beach.label': 'metros da praia',

  'home.about.label': 'A ACADEMIA',
  'home.about.title': 'FORÇA DE PRAIA, TREINO DE VERDADE',
  'home.about.text': 'A Top Gym Cumbuco é uma academia para quem quer treinar com estrutura, orientação e energia internacional. Seja você morador, visitante ou alguém passando uma temporada em Cumbuco, aqui o treino continua.',
  'home.about.feature1': 'Ambiente local',
  'home.about.feature2': 'Equipamentos e pesos livres',
  'home.about.feature3': 'Atendimento próximo',
  'home.about.feature4': 'Opções para diferentes objetivos',
  'home.about.cta': 'Fale conosco',

  'home.structure.title': 'Estrutura',
  'home.structure.titleHighlight': 'completa',
  'home.structure.subtitle': 'Conheça nossa estrutura pensada para todos os tipos de treino',

  'home.modalities.title': 'MODALIDADES',
  'home.modalities.subtitle': 'Musculação, cross training, circuito funcional e muay thai para todos os níveis.',
  'home.modalities.tagPopular': 'Mais Popular',

  'home.schedule.title': 'HORÁRIOS',
  'home.schedule.subtitle': 'Funcionamento e aulas para planejar seu treino',
  'home.schedule.weekday': 'Segunda a Sexta',
  'home.schedule.weekdayHours': '06h às 22h',
  'home.schedule.saturday': 'Sábado',
  'home.schedule.saturdayHours': '08h às 12h',
  'home.schedule.sunday': 'Domingo',
  'home.schedule.sundayHours': 'Fechado',
  'home.schedule.classTitle': 'Grade de Aulas',

  'home.testimonials.title': 'DEPOIMENTOS',
  'home.testimonials.rating': '4.9',
  'home.testimonials.navPrev': 'Anterior',
  'home.testimonials.navNext': 'Próximo',

  'home.store.label': 'Nossa Loja',
  'home.store.title': 'LOJA FITNESS',
  'home.store.subtitle': 'Moda fitness, suplementos e acessórios para potencializar seu treino e estilo de vida saudável.',
  'home.store.cta': 'Ver todos os produtos',

  'home.location.title': 'LOCALIZAÇÃO',
  'home.location.address': 'Av. Central, 2211 - Praia de Cumbuco, Caucaia - CE, 61619-270',
  'home.location.openMap': 'Abrir no Google Maps',
  'home.location.reference': 'Fica em Cumbuco, a poucos minutos da praia',

  'home.pricing.title': 'PLANOS',
  'home.pricing.subtitle': 'Escolha o plano ideal para a sua rotina. Fale com a gente no WhatsApp para começar.',
  'home.pricing.perMonth': '/mês',
  'home.pricing.tagBestValue': 'Melhor custo-benefício',
  'home.pricing.cta': 'Quero esse plano',
  'home.pricing.plan.monthly.name': 'Musculação Mensal',
  'home.pricing.plan.monthly.price': 'R$ 169',
  'home.pricing.plan.monthly.description': 'Acesso completo à área de musculação.',
  'home.pricing.plan.combo.name': 'Musculação + 1 Modalidade',
  'home.pricing.plan.combo.price': 'R$ 180',
  'home.pricing.plan.combo.description': 'Musculação e uma modalidade à sua escolha.',
  'home.pricing.plan.annual.name': 'Plano Anual Completo',
  'home.pricing.plan.annual.price': '12x R$ 130',
  'home.pricing.plan.annual.priceNote': 'no cartão de crédito',
  'home.pricing.plan.annual.description': 'Todas as modalidades inclusas por 12 meses.',
  'home.pricing.passes.title': 'De passagem por Cumbuco?',
  'home.pricing.passes.subtitle': 'Passes avulsos para visitantes e turistas.',
  'home.pricing.passes.day': 'Diária',
  'home.pricing.passes.dayPrice': 'R$ 35',
  'home.pricing.passes.week': 'Semana',
  'home.pricing.passes.weekPrice': 'R$ 110',
  'home.pricing.passes.fortnight': 'Quinzena',
  'home.pricing.passes.fortnightPrice': 'R$ 130',
  'home.pricing.whatsappMessage': 'Olá! Tenho interesse no plano: ',

  'home.cta.label': 'COMECE AGORA',
  'home.cta.title': 'PRONTO PARA TREINAR EM CUMBUCO?',
  'home.cta.text': 'Fale com a Top Gym e veja planos, horários e modalidades disponíveis.',
  'home.cta.button': 'Chamar no WhatsApp',
};